export { default } from './InlinePageText';
export * from './InlinePageText';
